import {
  ChemistryMeasurementReference,
  MaterialChemistry,
  SupportedLanguage,
} from "store/api/generatedApi";
import { parseNumber } from "src/utils/parseNumber";

export const parseChemistryMeasurement = ({
  text,
  language,
}: {
  text: string;
  language: SupportedLanguage;
}): number => {
  const measurement = parseNumber(language)({
    decimalPlaces: 4,
    minimum: 0,
    maximum: 99.9999,
  })(text.trim() === "" ? "0" : text);
  if (!Number.isFinite(measurement)) {
    throw new Error("Invalid chemistry measurement");
  }
  return measurement;
};

export const chemistryMeasurementKey = ({
  material_id,
  chemical_element_id,
}: ChemistryMeasurementReference): string =>
  `${material_id}-${chemical_element_id}`;

export const chemistryMeasurementsEqual = (
  first: MaterialChemistry | undefined,
  second: MaterialChemistry | undefined
): boolean => first?.loc === second?.loc && first?.scale === second?.scale;

export const mergeChemistryMeasurements = ({
  measurements,
  overrides,
}: {
  measurements: MaterialChemistry[];
  overrides: MaterialChemistry[];
}): Map<string, MaterialChemistry> =>
  new Map(
    [...measurements, ...overrides].map((measurement) => [
      chemistryMeasurementKey(measurement),
      measurement,
    ])
  );

export const chemistryMatchesDefaults = ({
  measurements,
  defaults,
}: {
  measurements: Map<string, MaterialChemistry>;
  defaults: MaterialChemistry[];
}): boolean =>
  measurements.size === defaults.length &&
  defaults.every((measurement) =>
    chemistryMeasurementsEqual(
      measurements.get(chemistryMeasurementKey(measurement)),
      measurement
    )
  );
